"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WriteTicketSet = void 0;

var OperationBase_1 = require("../OperationBase");

var StepTracker_1 = require("../StepTracker");

var ITelemetryClient_1 = require("../../ITelemetryClient");

var MsaTicketCache_1 = require("../../MsaTicketCache");

var Utils_1 = require("../../Utils");

var LoadUser_1 = require("./LoadUser");

var Step;

(function (Step) {
  Step["Start"] = "Start";
  Step["WritingTicketSet"] = "WritingTicketSet";
  Step["WritingDefaultUser"] = "WritingDefaultUser";
  Step["Done"] = "Done";
})(Step || (Step = {}));

var WriteTicketSet =
/** @class */
function (_super) {
  __extends(WriteTicketSet, _super);

  function WriteTicketSet(telemetryClient, authConfig, storage, ticketSet) {
    var _this = _super.call(this, telemetryClient) || this;

    _this.authConfig = authConfig;
    _this.storage = storage;
    _this.ticketSet = ticketSet;
    _this.step = new StepTracker_1.StepTracker(ITelemetryClient_1.Area.WriteTicketSet, Step.Start);
    return _this;
  }

  WriteTicketSet.prototype.run = function () {
    return __awaiter(this, void 0, void 0, function () {
      var key, error_1;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            this.step.advance(Step.WritingTicketSet);
            key = MsaTicketCache_1.MsaTicketCache.makeTicketSetKey(this.authConfig, this.ticketSet.ticketSet.userId);
            _a.label = 1;

          case 1:
            _a.trys.push([1, 3,, 4]);

            return [4
            /*yield*/
            , this.storage.write(key, this.ticketSet.ticketSet.serialize())];

          case 2:
            _a.sent();

            Utils_1.assert(this.step.currentStep === Step.WritingTicketSet);
            return [3
            /*break*/
            , 4];

          case 3:
            error_1 = _a.sent();
            Utils_1.xalTrace(Utils_1.TraceLevel.Warning, "Failed to write msa ticket set to storage with error " + error_1);
            return [3
            /*break*/
            , 4];

          case 4:
            return [4
            /*yield*/
            , this.writeDefaultUser()];

          case 5:
            _a.sent();

            return [2
            /*return*/
            ];
        }
      });
    });
  };

  WriteTicketSet.prototype.writeDefaultUser = function () {
    return __awaiter(this, void 0, void 0, function () {
      var key, error_2;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            this.step.advance(Step.WritingDefaultUser);
            key = MsaTicketCache_1.MsaTicketCache.makeDefaultUserKey(this.authConfig);
            _a.label = 1;

          case 1:
            _a.trys.push([1, 3,, 4]);

            return [4
            /*yield*/
            , this.storage.write(key, LoadUser_1.serializeDefaultUserBlob(this.ticketSet.ticketSet.userId))];

          case 2:
            _a.sent();

            Utils_1.assert(this.step.currentStep === Step.WritingDefaultUser);
            return [3
            /*break*/
            , 4];

          case 3:
            error_2 = _a.sent();
            Utils_1.xalTrace(Utils_1.TraceLevel.Warning, "Failed to write default user to storage with error " + error_2);
            return [3
            /*break*/
            , 4];

          case 4:
            this.step.advance(Step.Done);
            this.succeed(this.ticketSet);
            return [2
            /*return*/
            ];
        }
      });
    });
  };

  return WriteTicketSet;
}(OperationBase_1.OperationBase);

exports.WriteTicketSet = WriteTicketSet;